import { Add as AddIcon, DeleteOutline as DeleteIcon } from '@mui/icons-material';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { FormTextInput, GlobalButton } from '@/components';
import { Control, useFieldArray } from 'react-hook-form';
import { IconButton, Tooltip } from '@mui/material';
import {
  MAX_WEBHOOK_HEADERS,
  emptyWebhookHeaderRow,
  type WebhookHeaderRow,
} from '../models/WebhookHeaders';

interface WebhookHeadersFieldProps {
  control: Control<any>;
  name: string;
  disabled?: boolean;
}

const WebhookHeadersField = ({ control, name, disabled = false }: WebhookHeadersFieldProps) => {
  const { fields, append, remove } = useFieldArray({ control, name });
  const rows = fields as (WebhookHeaderRow & { id: string })[];

  return (
    <div className='flex flex-col gap-3'>
      <span className='text-sm text-gray-700'>Headers (opcional)</span>
      {rows.length === 0 && <p className='text-xs text-gray-500'>Sin headers.</p>}
      {rows.map((row, index) => (
        <div
          key={row.id}
          className='grid grid-cols-1 md:grid-cols-[1fr_1fr_auto] gap-3 items-start'
        >
          <FormTextInput
            control={control}
            name={`${name}.${index}.name`}
            placeholder='Nombre del header'
            disabled={disabled}
          />
          <FormTextInput
            control={control}
            name={`${name}.${index}.value`}
            placeholder={
              row.storedName ? 'Valor (vacío = se mantiene el guardado)' : 'Valor del header'
            }
            disabled={disabled}
          />
          <Tooltip title='Quitar header'>
            <span>
              <IconButton size='small' onClick={() => remove(index)} disabled={disabled}>
                <DeleteIcon fontSize='small' />
              </IconButton>
            </span>
          </Tooltip>
        </div>
      ))}
      {rows.length >= MAX_WEBHOOK_HEADERS ? (
        <p className='text-xs text-gray-500'>
          Se admiten hasta {MAX_WEBHOOK_HEADERS} headers por webhook.
        </p>
      ) : (
        <div>
          <GlobalButton
            variant={GlobalButtonVariant.textButton}
            size='small'
            action={() => append(emptyWebhookHeaderRow)}
            disabled={disabled}
          >
            <AddIcon fontSize='small' />
            Agregar header
          </GlobalButton>
        </div>
      )}
    </div>
  );
};

export default WebhookHeadersField;
